export default function DateFactory(moment) {
    var fn = this;

    fn.startOfDay = (m) => {
        moment(m).utcOffset(0);
        m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        m.toISOString();
        m.format();

        return m;
    };

    fn.addTimestamps = (arrayOfBookings) => {
        angular.forEach(arrayOfBookings, (booking) => {
            // ADD TIMESTAMPS
            booking.timeStampStart = moment(booking.BookingStart).format("x");
            booking.timeStampEnd = moment(booking.BookingEnd).format("x");
        });

        return arrayOfBookings;
    };

    fn.getWeekday = (timestamp) => {
        return moment(timestamp, "DD-MM-YYYY").toDate();
    };

    fn.getAsTimestamp = (date) => {
        return moment(date, "DD-MM-YYYY").format("X");
    };

    fn.getNowTimestamp = () => {
        return Date.now();
    };

    return fn;
}
